<app-i18n-dictionary xmlns="http://www.w3.org/1999/html">
    <span [attr.transid]="titleTextId" i18n="@@download_title">Press & Downloads</span>
</app-i18n-dictionary>

<div class="container">
    <div class="teaser">
        <div class="col headline">
            <div class="welcome">
                <div i18n="@@download_headline">Press<br/>& Downloads</div>
            </div>
        </div>
        <div class="col right">
            <p>
                <app-cms-block blockId="downloads_header_content"></app-cms-block>
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="title">
                <app-cms-block blockId="downloads_row_1_title"></app-cms-block>
            </div>
        </div>
        <div class="col" fxLayout="column" fxLayoutAlign="center">
            <div class="press-description" fxLayout="column" fxLayoutAlign="center">
                <app-cms-block blockId="downloads_row_1_content"></app-cms-block>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="title">
                <app-cms-block blockId="downloads_row_2_title"></app-cms-block>
            </div>
        </div>
        <div class="col split">
            <div class="sub-col image">
                <app-cms-block blockId="downloads_row_2_image"></app-cms-block>
            </div>
            <div class="sub-col press-description" fxLayout="column">
                <app-cms-block blockId="downloads_row_2_content"></app-cms-block>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="title">
                <app-cms-block blockId="downloads_row_3_title"></app-cms-block>
            </div>
        </div>
        <div class="col">
            <div class="press-description" fxLayout="row" fxLayoutAlign="flex-start">
                <app-cms-block blockId="downloads_row_3_content" fxFlex></app-cms-block>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="title">
                <app-cms-block blockId="downloads_row_4_title"></app-cms-block>
            </div>
        </div>
        <div class="col" fxLayout="column" fxLayoutAlign="center">
            <div class="press-description" fxLayout="column" fxLayoutAlign="center">
                <app-cms-block blockId="downloads_row_4_content"></app-cms-block>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="title">
                <app-cms-block blockId="downloads_row_5_title"></app-cms-block>
            </div>
        </div>
        <div class="col" fxLayout="column" fxLayoutAlign="center">
            <div class="press-description" fxLayout="column" fxLayoutAlign="center">
                <app-cms-block blockId="downloads_row_5_content"></app-cms-block>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="title">
                <app-cms-block blockId="downloads_row_6_title"></app-cms-block>
            </div>
        </div>
        <div class="col" fxLayout="column" fxLayoutAlign="center">
            <div class="press-description" fxLayout="column" fxLayoutAlign="center">
                <app-cms-block blockId="downloads_row_6_content"></app-cms-block>
            </div>
        </div>
    </div>

</div>


